import * as actionTypes from "../actions/actionTypes";

const initialState: {} = {
  favoritedProvider: false,
  favoriteProviderStart: false,
  favoritedProviderError: false,
  unFavoritedProvider: false,
  unFavoriteProviderStart: false,
  unFavoritedProviderError: false,
  favoritedProviderId: null,
  unFavoritedProviderId: null,
};
const favoriteProvider = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FAVORITE_PROVIDER_STARTED: {
      return {
        ...state,
        favoritedProvider: false,
        favoriteProviderStart: true,
        favoritedProviderError: false,
        unFavoritedProviderError: false,
        favoritedProviderId: null,
      };
    }
    case actionTypes.FAVORITE_PROVIDER_SUCCESS: {
      return {
        ...state,
        favoritedProvider: true,
        favoriteProviderStart: false,
        favoritedProviderError: false,
        unFavoritedProviderError: false,
        favoritedProviderId: action.favoritId,
      };
    }
    case actionTypes.UNFAVORITE_PROVIDER_STARTED: {
      return {
        ...state,
        unFavoritedProvider: false,
        unFavoriteProviderStart: true,
        favoritedProviderError: false,
        unFavoritedProviderError: false,
        unFavoritedProviderId: null,
      };
    }
    case actionTypes.UNFAVORITE_PROVIDER_SUCCESS: {
      return {
        ...state,
        unFavoritedProvider: true,
        favoritedProviderError: false,
        unFavoritedProviderError: false,
        unFavoriteProviderStart: false,
        unFavoritedProviderId: action.favoritId,
      };
    }
    case actionTypes.RESET_UNFAVORITE_PROVIDER_SUCCESS: {
      return {
        ...state,
        unFavoritedProvider: false,
        unFavoriteProviderStart: false,
        unFavoritedProviderError: false,
        unFavoritedProviderId: null,
      };
    }
    case actionTypes.RESET_FAVORITE_PROVIDER_SUCCESS: {
      return {
        ...state,
        favoritedProvider: false,
        favoriteProviderStart: false,
        favoritedProviderError: false,
        favoritedProviderId: null,
      };
    }
    default:
      return state;
  }
};
export default favoriteProvider;
